export default function getIds<T>(items: T[] | undefined, getItemId: (item: T) => string) {
    if (!items) {
        return [];
    }

    return items.map(getItemId);
}
